import React from 'react';
import styles from "./UnderstoodButton.module.scss";
import LinkBlockContainer from 'data/redux/containers/linkBlockContainer';
import {IProduct} from 'data/interfaces/products';
import {linksMap} from 'data/utils/constants';


interface IUnderstoodButtonProps {
  product?: Partial<IProduct>;
  loading?: boolean;
}

//to={props.product ? generateSluggedAdUrl(props.product) : linksMap.productsByMe}
const UnderstoodButton = (props: IUnderstoodButtonProps) => (
  <LinkBlockContainer to={linksMap.dashboard}
                      className={styles.UnderstoodButtonLink}
                      loading={props.loading}
  >
    הבנתי!
  </LinkBlockContainer>);

UnderstoodButton.defaultProps = {};

export default React.memo(UnderstoodButton);
